import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Panel } from '@sites/data-hmm/hmm-ninja';

export const panelServiceActions = createActionGroup({
  source: 'DashboardStore PanelService',
  events: {
    list: emptyProps(),
    listRefresh: emptyProps(),
    listSuccess: props<{ panels: Panel[] }>(),
    listFailure: props<{ error: Error }>(),
  },
});
